/**
 * A mixin to bind general config data to any component which requires it
 */
import { staticUrl } from '@/../../shared/src/utils/constants'

export default {
  name: 'Config',
  computed: {

    staticUrl () {
      return staticUrl
    },

    isWidget () {
      return this.config.isWidget
    },

    isEventOwner () {
      return this.config.classroom && this.config.classroom.event.owner.id === this.config.user.id
    },

    isPrimaryTeacher () {
      try {
        return (this.config.classroom.event.owner.id === this.config.user.id) && this.this.config.user.isteacher
      } catch (err) {
        return false
      }
    },

    isSuperUser () {
      return this.config.user.superuser
    },

    teacherPermissions () {
      if (this.config.app === 'recordings') {
        return false
      }
      return !!(this.config.user.isteacher || this.config.user.superuser)
    },

    isTeacher () {
      return this.config.user.isteacher
    },

    isStaff () {
      return this.config.user.isstaff
    },

    isBreakoutRoom () {
      return !!(this.config.classroom && this.config.classroom.event && this.config.classroom.event.breakout_parent)
    },

    isMobile () {
      return this.$store.getters['config/isMobile']
    },

    isTablet () {
      return this.$store.getters['config/isTablet']
    },

    classroomId () {
      return this.$store.getters['config/classroomId']
    },

    isTouchScreen () {
      return (this.isMobile || this.isTablet)
    },

    isEmbeddedWhiteboard () {
      return this.$store.state.config.classroom.settings.embedded_whiteboard
    },

    coloursById () {
      return this.$store.getters['classroom/coloursById'] || {}
    },

    activeUserColour () {
      const user = this.$store.getters['classroom/classroomUser'] || {}
      return user.colour || this.config.user.meta.colour
    },

    screenshareTool () {
      const canShare = navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia
      const enabled = (this.config.classroom.lesson_materials.enable_screenshare || this.config.classroom.lesson_materials.enable_doc_cam)
      const notEmbeddedWhiteboard = !(this.isEmbeddedWhiteboard && this.$store.state.classroom.videoProvider === 'twilio')
      const desktop = !this.isTouchScreen
      return canShare && enabled && notEmbeddedWhiteboard && desktop
    },

    lessonMaterialsTool () {
      return (this.teacherPermissions || this.isBreakoutRoom || this.config.classroom.lesson_materials.can_upload)
    },

    dashboardUrl () {
      return this.config.classroom.settings.dashboardUrl || this.config.classroom.dashboardUrl || '/'
    },

    isDemoClass () {
      return this.config.classroom.settings.is_demo
    },

    config () {
      return this.$store.state.config
    }
  }
}
